import { Component, OnInit, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import * as moment from 'moment';
import { SubjectService } from 'src/app/services/subject.service';
import { SkuDataService } from 'src/app/services/sku-data.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { CartService } from 'src/app/services/cart.service';
import { LanguageSwitchService } from 'src/app/services/language-switch.service';
import { TranslateService } from '@ngx-translate/core';
import { AppiceService } from 'src/app/services/appice.service';
import { AppiceHomeWirelessService } from 'src/app/services/appice-homewireless.service';
import { AdobeAnalyticsService } from 'src/app/services/adobe-analytics.service';
import { ApplicationInitializationService } from 'src/app/services/application-initialization.service';
import { AdjustTokenService } from 'src/app/services/adjust-token.service';
import { AppSettings } from 'src/app/enums/app-settings.enum';
import { SIM_TYPE, SIM_TYPE_ORIENTATION } from 'src/app/enums/plansSubType.enum';
@Component({
  selector: 'app-success',
  templateUrl: './success.component.html',
  styleUrls: ['./success.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SuccessComponent implements OnInit, AfterViewInit {
  currentLanguage: string = '';
  preferredNumberMessage: any;
  sku: any;
  transactionId: any;
  mobileNumber: any;
  billType: any;
  price: any;
  email: any;
  ENV: string = '';
  userInfo: any;
  isNavCollapsed = true;
  isVisitorLine: boolean;
  cart: any;
  documentSubmissionStatus : any;
  isUAEPassOrder = false;
  showBanner=false;
  navigateTo='';
  checkeSimeavailable:boolean = false;
  checkoutdata: any;
  checkBlankSimAvailable:boolean = false
  tradein: boolean = false;
  tradeinbanaer:any = 'FALSE'
  isAddonCart: boolean = false;
  selectedAppleCareDevice: any = null;
  esimOnly: any = false;
  stitchFields:any;
  planData: any;
  isFRMOIEnabled: boolean = false;
  isFRMOIAppReleaseEnabled: boolean = false;
  constructor(
    private modalController: ModalController,
    private UTS: UtilitiesService,
    private SKUDS: SkuDataService,
    private SS: SubjectService,
    private aRoute: ActivatedRoute,
    private GAS: GoogleAnalyticsService,
    private CS: CartService,
    private LSS: LanguageSwitchService,
    private translate: TranslateService,
    private appice: AppiceService,
    private appiceHwService: AppiceHomeWirelessService,
    private AAS: AdobeAnalyticsService,
    private appInitService: ApplicationInitializationService,
    private adjustToken:AdjustTokenService

  ) {
    this.handleAppleCareData();
    this.aRoute.queryParams.subscribe((q) => {
      if (q && q.env) {
        this.UTS.setENV(q.env);
        this.ENV = q.env;
      }
      if (q && q.orderId) {
        this.transactionId = q.orderId;
      }
      if(q && q?.esime){
        this.checkeSimeavailable = q?.esime;
        if(q.esime == "false"){
          this.checkeSimeavailable = false;
        }
      }
      if(q && q?.blanksim){
        this.checkBlankSimAvailable = q?.blanksim;
        if(q?.blanksim == "false"){
          this.checkBlankSimAvailable = false;
        }
      }
      if (q && q.email) {
        if(q?.email !=='undefined'){
          this.email = q.email;
        }
      }
      this.userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if (this.userInfo && !this.isAddonCart) {
        this.email = this.userInfo.email;
      }
      if(this.isAddonCart){
        this.email = sessionStorage.getItem('appleCareCartEmail');
      }

      if (sessionStorage.getItem('uaePassProperties')) {
        let uaePassProperties = JSON.parse(sessionStorage.getItem('uaePassProperties'));
        this.isUAEPassOrder = uaePassProperties?.uaePassFlow;      
        this.documentSubmissionStatus  =  uaePassProperties?.documentSubmissionStatus;

      }

      this.currentLanguage = this.UTS.getLocaleLanguage();
    })

  }

  ngOnInit() {
    this.stitchFields = this.aRoute?.snapshot?.queryParams;
    this.tradeinbanaer = this.appInitService?.environmentConfig?.TRADE_IN_BANAER_CHECKOUT_DISABLE ? this.appInitService?.environmentConfig?.TRADE_IN_BANAER_CHECKOUT_DISABLE : 'FALSE' 
    this.planData = this.UTS.getPlanData();
    this.isFRMOIEnabled = this.appInitService?.environmentConfig?.IS_FR_MOI_ENABLED ?? false;
    this.isFRMOIAppReleaseEnabled = this.appInitService?.environmentConfig?.IS_FR_MOI_APP_RELEASE_ENABLED ?? false;
    this.cart = this.CS.getCart();
    this.getBannerInfo();
    if(localStorage.getItem('CS') && JSON.parse(localStorage.getItem('CS'))){
      this.cart =  JSON.parse(localStorage.getItem('CS'));
    }
    if(localStorage.getItem('esimOnly')){
      this.esimOnly = true;
    }else{
      this.esimOnly = false;
    }
    
    this.GAS.CJSteps(this.cart,'success_screen_page_load');
    this.optimizeCheckoutTracking('purchase');
    this.GAS.purchaseTracking(this.cart,'purchase', this.transactionId,this.email);
    this.AAS.orderSuccessEvent(this.transactionId, this.cart?.totalPayNow, this.cart)
    this.currentLanguage = this.UTS.getLocaleLanguage();
    this.sku = this.SKUDS.get();
    const visitorlineDetails = JSON.parse(localStorage.getItem('visitorlineDetails'))
    this.tradein = sessionStorage.getItem('CheckSuccessTradeIN') == 'true' ? true : false;
    sessionStorage.removeItem('CheckSuccessTradeIN')
    this.isVisitorLine = false;
    if (visitorlineDetails) {
      this.isVisitorLine = true;
      localStorage.removeItem('visitorlineDetails')
      if(visitorlineDetails && visitorlineDetails?.visitorDetail && visitorlineDetails?.visitorDetail?.email){
        this.email = visitorlineDetails?.visitorDetail?.email 
      }
    }
    this.ENV = this.UTS.getENV();
    if (this.cart && this.cart?.items && this.cart.items.length > 0 && this.ENV && this.ENV !== 'mobile') {
      for (let item of this.cart?.items) {
        this.appice.passAllProductsToCart("Cart", "Purchases", item, this.userInfo)
        this.appiceHwService.passAllProductsToCart("Order Confirmation Page" ,"Purchase", item);
      }
    }
    if(localStorage.getItem('eSime') && JSON.parse(localStorage.getItem('eSime'))){
      this.checkoutdata = JSON.parse(localStorage.getItem('eSime'))
    }else{
      this.checkeSimeavailable = false;
    }
    //localStorage.removeItem('eSime');
    sessionStorage.removeItem('3MonthsFreePromoForXAA');
    this.UTS.clearTravelInsuranceData();
    this.ENV = this.UTS.getENV();
  }
  ngAfterViewInit(): void {
    if (this.ENV == 'mobile' && this.cart && this.cart?.items && this.cart?.items?.length > 0) {
      this.cart?.items?.forEach(element => {
        if (element && element?.commerceItemType && element?.commerceItemType == 'mobileDevicesSku') {
          this.adjustToken.devicesAdjustTracking('ec_purchase', AppSettings.PURCHASE_SUCCESS_ADJUST_TOKEN, element);
        }
        if (element && element?.productType && element?.productType == 'MOBILE_POSTPAID') {
          this.adjustToken.trackEvent(AppSettings.POSTPAID_SUCCESS_EVENT);
        }
      });
    }
    
    // setTimeout(() => {
    //   if(localStorage.getItem('CS')){
    //     this.GAS.onPurchase(JSON.parse(localStorage.getItem('CS')), 1, '',this.transactionId);
    //   }
    // }, 1500);
  }
  ok() {
    this.dismiss();
  }

  cancel() {
    this.dismiss();
  }

  closePopUpEN() {
    this.dismiss();
  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    // this.modalController.dismiss({
    //   dismissed: true,
    // });

    window.location.href = environment.HOST + '/b2c/eshop/userOrdersTracking';
  }

  letGoPopUpLinkEN() {
    const browserName = this.getBrowserInfo();

    var feedbackHost =
      'https://feedback.etisalat.ae/collection/collection.aspx?cguid=9e4-b515de8da5e0&langid=1&sessionCustomText5=&sessionCustomText6=&consumerAccount=&sessionCustomText8=' +
      browserName +
      '&sessionCustomText9=WEB';
    window.open(feedbackHost, '_blank');
  }

  closePopUpAR() {
    this.dismiss();
  }

  letGoPopUpLinkAR() {
    const browserName = this.getBrowserInfo();

    const feedbackHost =
      'https://feedback.etisalat.ae/collection/collection.aspx?cguid=9e4-b515de8da5e0&langid=22&sessionCustomText5=&sessionCustomText6=&consumerAccount=&sessionCustomText8=' +
      browserName +
      '&sessionCustomText9=WEB';
    window.open(feedbackHost, '_blank');
  }

  getBrowserInfo() {
    const nVer = navigator.appVersion;
    const nAgt = navigator.userAgent;
    let browserName = navigator.appName;
    let fullVersion = '' + parseFloat(navigator.appVersion);
    let majorVersion = parseInt(navigator.appVersion, 10);
    let nameOffset, verOffset, ix;

    // In Opera, the true version is after "Opera" or after "Version"
    if ((verOffset = nAgt.indexOf('Opera')) != -1) {
      browserName = 'Opera';
      fullVersion = nAgt.substring(verOffset + 6);
      if ((verOffset = nAgt.indexOf('Version')) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In MSIE, the true version is after "MSIE" in userAgent
    else if ((verOffset = nAgt.indexOf('MSIE')) != -1) {
      browserName = 'Microsoft Internet Explorer';
      fullVersion = nAgt.substring(verOffset + 5);
    }
    // In Chrome, the true version is after "Chrome"
    else if ((verOffset = nAgt.indexOf('Chrome')) != -1) {
      browserName = 'Chrome';
      fullVersion = nAgt.substring(verOffset + 7);
    }
    // In Safari, the true version is after "Safari" or after "Version"
    else if ((verOffset = nAgt.indexOf('Safari')) != -1) {
      browserName = 'Safari';
      fullVersion = nAgt.substring(verOffset + 7);
      if ((verOffset = nAgt.indexOf('Version')) != -1)
        fullVersion = nAgt.substring(verOffset + 8);
    }
    // In Firefox, the true version is after "Firefox"
    else if ((verOffset = nAgt.indexOf('Firefox')) != -1) {
      browserName = 'Firefox';
      fullVersion = nAgt.substring(verOffset + 8);
    }
    // In most other browsers, "name/version" is at the end of userAgent
    else if (
      (nameOffset = nAgt.lastIndexOf(' ') + 1) <
      (verOffset = nAgt.lastIndexOf('/'))
    ) {
      browserName = nAgt.substring(nameOffset, verOffset);
      fullVersion = nAgt.substring(verOffset + 1);
      if (browserName.toLowerCase() == browserName.toUpperCase()) {
        browserName = navigator.appName;
      }
    }

    // trim the fullVersion string at semicolon/space if present
    if ((ix = fullVersion.indexOf(';')) != -1)
      fullVersion = fullVersion.substring(0, ix);
    if ((ix = fullVersion.indexOf(' ')) != -1)
      fullVersion = fullVersion.substring(0, ix);

    majorVersion = parseInt('' + fullVersion, 10);
    if (isNaN(majorVersion)) {
      fullVersion = '' + parseFloat(navigator.appVersion);
      majorVersion = parseInt(navigator.appVersion, 10);
    }

    return browserName;
  }

  getValidity(v: any) {
    if (v) {
      return v == 'Monthly' ? ' 1 Month ' : v == 'Weekly' ? '1 Week' : '1 Day';
    }
    return v;
  }
  today() {
    const lang = this.UTS.getLocaleLanguage();
    if (lang == 'ar') {
      moment.locale('ar-tn');
      return moment(Date.now()).format('Do MMM, YYYY');
    } else {
      moment.locale('en');
      return moment(Date.now()).format('Do MMM, YYYY'); // 13th April, 2020
    }
  }

  goToTrackOrders() {
    const OS = this.UTS.getMobileOperatingSystem();
    this.ENV = this.UTS.getENV();
    if (this.ENV == 'mobile') {
      if (OS == 'Android') {
        (window as any).deals.goToTrackOrders();
      } else {
        (window as any).webkit.messageHandlers.hybridInterface.postMessage('goToTrackOrders');
      }
    }
    else {
      const lang = localStorage.getItem('language') && localStorage.getItem('language').toLocaleLowerCase();
      window.location.href = environment.HOST + `/b2c/eshop/userOrdersTracking?locale=${lang}`;
    }
  }

  gotoPostpaid(){
    const lang = localStorage.getItem('language') && localStorage.getItem('language').toLocaleLowerCase();
    window.location.href = environment.HOST + this.navigateTo +'&lang='+lang;
  }

  getBannerInfo() {
    this.CS.getBannerInfo().subscribe(
      (r: any) => {
        if (r && r.showBanner) {
          if(sessionStorage.getItem('purchasedOnlyDevices')=='true' && r.showBanner){
            this.showBanner=true;
            this.navigateTo=r.navigateTo;
          } else this.showBanner=false;
        }
      },
      (e) => {
        if (e && e.error) {
          this.UTS.error(e.error.message);
        }
      }
    );
  }
  public handleAppleCareData(): void{
    this.isAddonCart = sessionStorage.getItem('isAddonCart')  ? sessionStorage.getItem('isAddonCart') === 'true' : false;
    if(sessionStorage.getItem('selectedDevice')){
        this.selectedAppleCareDevice = JSON.parse(sessionStorage.getItem('selectedDevice'));
    }
    this.email = sessionStorage.getItem('appleCareCartEmail');

  }
  public clearAppleCareData(): void{
    ['selectedDevice','appleCarePaymentSku','selectedAccountForSmartPay','isAddonCart'].forEach(item => localStorage.remove(item));
  }
  optimizeCheckoutTracking(event) {
    if (this.cart?.items?.length > 0) {
      const hasEligibleItem = this.cart.items.some(element =>
        element && element.commerceItemCategory && element.commerceItemCategory == 'Prepaid_plan');    
      const match = this.cart?.items.find(element => element?.commerceItemCategory === "Prepaid_plan");
      const subSection = match ? match.parentDisplayName + ' ' + match.displayName : "";
      if (hasEligibleItem) {//only for postpaid plans
        this.GAS.checkoutOptimizationTracking(event, this.cart?.items, this.cart, 'Configuration page', '', 'prepaid purchase success', '', subSection, this.cart?.totalRechargeAmount,this.stitchFields);
      } else {
        const hasEligibleItemPostpaid = this.cart.items.some(element =>
          element && element.commerceItemCategory && element.commerceItemCategory == 'Postpaid_plan');
        if (hasEligibleItemPostpaid) {//only for postpaid plans
          this.GAS.checkoutOptimizationTracking(event, this.cart?.items, this.cart, 'Configuration page', '', 'postpaid purchase success', '', '', this.cart?.totalRechargeAmount);
        } else {
          this.GAS.purchaseTracking(this.cart, event, this.transactionId,this.email);
        }
      }
    }
  }

  get simType(){
    return SIM_TYPE;
  }

  get userFrom(){
    return SIM_TYPE_ORIENTATION;
  }

  get canCheckPlanData(): boolean{
    if (this.ENV == 'mobile') {
      return this.isFRMOIAppReleaseEnabled;
    }
    return this.isFRMOIEnabled;
  }
  
  get showOrderSuccessContainer() {
    const baseChecks = 
    !this.isUAEPassOrder &&
    !this.checkeSimeavailable &&
    !this.checkBlankSimAvailable;
    if(!this.canCheckPlanData){
      return baseChecks;
    }

      return baseChecks &&
           !(this.planData?.simType === this.simType.PHYSICAL_SIM &&
             (this.planData?.userFrom === this.userFrom.PHYSICAL_SIM_FR ||
              this.planData?.userFrom === this.userFrom.VERIFY_IN_PERSON));
  }
   
  get showPhysicalSimOrderContainer() {
    const baseChecks = 
    !this.checkeSimeavailable &&
    !this.checkBlankSimAvailable &&
    !this.isUAEPassOrder;
    if(!this.canCheckPlanData){
      return baseChecks;
    }
    return baseChecks && this.planData?.simType === this.simType.PHYSICAL_SIM &&
      (this.planData?.userFrom === this.userFrom.PHYSICAL_SIM_FR ||
       this.planData?.userFrom === this.userFrom.VERIFY_IN_PERSON);
  }

  ngOnDestroy() {
    sessionStorage.removeItem('uaePassflow');
    sessionStorage.removeItem('uaePassProperties');
    const transactionalSurvey = JSON.parse(localStorage.getItem('transactionalSurvey'));
    if (transactionalSurvey) {
      localStorage.removeItem('transactionalSurvey');
    }
    const relationalSurvey = JSON.parse(localStorage.getItem('relationalSurvey'));
    if (relationalSurvey) {
      localStorage.removeItem('relationalSurvey');
    }
    if(this.isAddonCart) this.clearAppleCareData();

    this.UTS.clearPlanData();
  }

  goToEsim(){
    if(this.ENV == 'mobile'){
      window.location.href = `${window.location.origin}/${this.currentLanguage}/c/devices/new-device-launch/esim-app.html`;
    }else{
      window.location.href = `${window.location.origin}/${this.currentLanguage}/c/devices/new-device-launch/esim.html`;
    }
  }
  
}
